/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Typescript_Ex_TitleInputs */

const en_to_typescript_ex_title = /** @type {(inputs: To_Typescript_Ex_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generating interfaces from an array of records`)
};

const ko_to_typescript_ex_title = /** @type {(inputs: To_Typescript_Ex_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`레코드 배열에서 인터페이스 생성하기`)
};

const ja_to_typescript_ex_title = /** @type {(inputs: To_Typescript_Ex_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レコードの配列からインターフェースを生成する`)
};

/**
* | output |
* | --- |
* | "Generating interfaces from an array of records" |
*
* @param {To_Typescript_Ex_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_typescript_ex_title = /** @type {((inputs?: To_Typescript_Ex_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Typescript_Ex_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_typescript_ex_title(inputs)
	if (locale === "ko") return ko_to_typescript_ex_title(inputs)
	return ja_to_typescript_ex_title(inputs)
});